import { createContext } from 'react';

type UserContextProps = {
  full_name: string;
  short_name: string;
  profile_picture: string;
  subscription_type: string;
};

export const UserContext = createContext<UserContextProps>({
  full_name: '',
  short_name: '',
  profile_picture: '',
  subscription_type: ''
});

export const UserContextProvider = UserContext.Provider;
